module.exports = __webpack_public_path__ + "static/img/empty.ceef09b4.png";